import React, { useState, useEffect } from "react";
import DashboardHeader from "./DashboardHeader";
import ChefWidget from "./ChefWidget";
import OrderWidget from "./OrderWidget";
import RevenueWidget from "./RevenueWidget";
import ChefApprovalWidget from "./ChefApprovalWidget";
import AdminLogin from "./AdminLogin";
import MultiImageUploader from "../MultiImageUploader";
import ChefDishManager from "../ChefDishManager";
import BulkDishCreator from "../BulkDishCreator";
import "./Dashboard.css";

export default function Dashboard() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if admin token exists and is valid
    const checkAuth = async () => {
      const token = localStorage.getItem('admin_token');
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const response = await fetch('/api/admin/chefs?status=pending', {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.ok) {
          setIsAuthenticated(true);
        } else {
          localStorage.removeItem('admin_token');
        }
      } catch (error) {
        localStorage.removeItem('admin_token');
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    setIsAuthenticated(false);
  };

  if (loading) {
    return (
      <div className="dashboard-container">
        <div className="loading">Loading admin panel...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <AdminLogin onLogin={handleLogin} />;
  }

  return (
    <div className="dashboard-container">
      <DashboardHeader title="Admin Dashboard" />
      <div className="admin-controls">
        <button onClick={handleLogout} className="logout-btn">
          Logout
        </button>
      </div>
      <div className="widgets-container">
        <ChefApprovalWidget />
        <ChefWidget />
        <OrderWidget />
        <RevenueWidget />
        
        {/* Multi-Image Uploader for Gourmet Dishes */}
        <div className="admin-tool-section">
          <h2>Bulk Image Upload</h2>
          <MultiImageUploader 
            category="dishes"
            maxFiles={20}
            onUploadComplete={(results) => {
              console.log('Dish images uploaded:', results);
              alert(`Successfully uploaded ${results.length} dish images!`);
            }}
          />
        </div>

        {/* Chef-Dish Management System */}
        <div className="admin-tool-section">
          <ChefDishManager />
        </div>

        {/* Bulk Dish Creator */}
        <div className="admin-tool-section">
          <BulkDishCreator />
        </div>
      </div>
    </div>
  );
}